export function marketsPermissionTransform(data, params) {
    return data.attachment;
}
